import { API_DEVELOP, API_PRODUCT } from 'common/const';

const address = process.env.NODE_ENV === 'development' ? API_DEVELOP : API_PRODUCT;

function createApiAddress(endpoint: string): string {
  return `${address}${endpoint}`;
}

export default createApiAddress;
